import { useEffect, useState } from 'react'
import ClientSMSChat from '../ClientSMSChat'
import { apiURL } from '../../../../../utilities/URLs'
import { account } from '../../../../../classes/Account'

export default function DashboardOnlineAgentTile({ applicationId }) {
  const [hasAgent, setHasAgent] = useState(null)

  useEffect(() => {
    if (!applicationId) return
    const checkAgent = async () => {
      try {
        const res = await fetch(`${apiURL}/api/applications/${applicationId}/agent`, {
          headers: { 'Authorization': account.accessToken }
        })
        const data = await res.json()
        setHasAgent(!!data.response?.agent)
      } catch {
        setHasAgent(false)
      }
    }
    checkAgent()
  }, [applicationId])

  if (!hasAgent) return null

  return (
    <div className='w-full sm:w-1/3 rounded-2xl bg-white dark:bg-slate-800 border border-gray-100 dark:border-slate-700 shadow-sm flex flex-col overflow-hidden text-slate-800 dark:text-gray-100 transition-colors duration-300' style={{ minHeight: '420px', maxHeight: '520px' }}>
      <ClientSMSChat applicationId={applicationId} />
    </div>
  )
}